import React from 'react';
const Button = React.memo((props) => {
    var _a;
    const defaultClasses = [
        'border', 'py-1.5', 'px-4', 'rounded-md', 'shadow-md', 'bg-ps-white'
    ];
    let classes = [...defaultClasses, ...(_a = props.addClasses) !== null && _a !== void 0 ? _a : []];
    if (props.resetClasses) {
        classes = [...props.resetClasses];
    }
    return (React.createElement("button", { className: classes.join(' '), onClick: props.onClick, id: props.id, value: props.value, disabled: props.disabled }, props.label));
});
export default Button;
